import React, { ReactNode, useEffect } from "react";
import Header from "./Header";
import ProfileHeader from "./ProfileHeader";
import useBioDataStatusCheck from "../Helpers/useBioDataStatusCheck"; // Import your hook

const Layout = ({ children }: { children: ReactNode }) => {
    useBioDataStatusCheck(); // Call the hook to start monitoring bioDataStatus

    return (
        <div>
            <Header />
            <ProfileHeader />
            {children}
        </div>
    );
};

export default Layout;
